/* Dogshood Harness — storefront behaviour (no dependencies; uses Dawn's pubsub + cart drawer). */
(function () {
  'use strict';

  var C = window.DH_CONFIG || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Money ---------------- */
  function money(cents) {
    var fmt = C.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }
  window.DHMoney = money;

  /* Dawn declares PUB_SUB_EVENTS with a top-level const, so it is a global binding but not a window property. */
  function pubSubEvents() {
    try { return typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS; } catch (e) { return window.PUB_SUB_EVENTS; }
  }

  /* ---------------- Scroll reveal ---------------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.dh-reveal:not(.is-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Countdown ---------------- */
  if (!customElements.get('dh-countdown')) {
    customElements.define('dh-countdown', class extends HTMLElement {
      connectedCallback() {
        this.timer = this.querySelector('[data-dh-timer]');
        var endAttr = this.dataset.end || C.countdownEnd || '';
        this.fixedEnd = endAttr ? new Date(endAttr) : null;
        if (this.fixedEnd && isNaN(this.fixedEnd.getTime())) this.fixedEnd = null;
        this.tick = this.tick.bind(this);
        this.tick();
        this.interval = setInterval(this.tick, 1000);
      }
      disconnectedCallback() { clearInterval(this.interval); }
      target() {
        var now = new Date();
        if (this.fixedEnd && this.fixedEnd > now) return this.fixedEnd;
        var midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0);
        return midnight;
      }
      tick() {
        if (!this.timer) return;
        var diff = Math.max(0, this.target() - new Date());
        var h = Math.floor(diff / 3600000), m = Math.floor((diff % 3600000) / 60000), s = Math.floor((diff % 60000) / 1000);
        var pad = function (n) { return String(n).padStart(2, '0'); };
        this.timer.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
    });
  }

  /* ---------------- Delivery estimate ---------------- */
  function addBusinessDays(date, days) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  if (!customElements.get('dh-delivery')) {
    customElements.define('dh-delivery', class extends HTMLElement {
      connectedCallback() {
        var n = function (v, d) { var x = parseInt(v, 10); return isNaN(x) ? d : x; };
        var pmin = n(this.dataset.pmin, 1), pmax = n(this.dataset.pmax, 3), tmin = n(this.dataset.tmin, 5), tmax = n(this.dataset.tmax, 10);
        var lang = document.documentElement.lang || 'en';
        var f = new Intl.DateTimeFormat(lang, { month: 'short', day: 'numeric' });
        var today = new Date();
        var s1 = addBusinessDays(today, pmin), s2 = addBusinessDays(today, pmax);
        var d1 = addBusinessDays(s1, tmin), d2 = addBusinessDays(s2, tmax);
        var range = function (a, b) { var x = f.format(a), y = f.format(b); return x === y ? x : x + ' – ' + y; };
        var el0 = this.querySelector('[data-dh-d0]'), el1 = this.querySelector('[data-dh-d1]'), el2 = this.querySelector('[data-dh-d2]');
        if (el0) el0.textContent = f.format(today);
        if (el1) el1.textContent = range(s1, s2);
        if (el2) el2.textContent = range(d1, d2);
      }
    });
  }

  /* ---------------- Modals (size guide) ---------------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-dh-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-dh-open'));
      if (dlg && typeof dlg.showModal === 'function') {
        e.preventDefault();
        dlg._opener = opener;
        dlg.showModal();
        var closeBtn = dlg.querySelector('[data-dh-close]');
        if (closeBtn) closeBtn.focus();
      }
      return;
    }
    var closer = e.target.closest('[data-dh-close]');
    if (closer) {
      var d = closer.closest('dialog');
      if (d) d.close();
      return;
    }
    // The panel fills the dialog, so a click whose target is the dialog itself landed on the backdrop.
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('dh-modal')) e.target.close();
  });
  document.addEventListener('close', function (e) {
    if (e.target && e.target._opener) { e.target._opener.focus(); e.target._opener = null; }
  }, true);

  /* ---------------- Gallery ---------------- */
  if (!customElements.get('dh-gallery')) {
    customElements.define('dh-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.dh-gallery__track');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('.dh-gallery__slide'));
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-dh-thumb]'));
        this.counter = this.querySelector('[data-dh-current]');
        this.index = 0;
        var self = this;
        var prev = this.querySelector('[data-dh-prev]'), next = this.querySelector('[data-dh-next]');
        if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
        if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
        this.thumbs.forEach(function (t) { t.addEventListener('click', function () { self.go(parseInt(t.dataset.dhThumb, 10)); }); });
        if (this.track) {
          this.track.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); }
            if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); }
          });
          var raf;
          this.track.addEventListener('scroll', function () {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(function () {
              var w = self.track.clientWidth || 1;
              var i = Math.round(self.track.scrollLeft / w);
              if (i !== self.index) self.setActive(i);
            });
          }, { passive: true });
        }
      }
      go(i) {
        var n = this.slides.length;
        if (!n) return;
        i = (i + n) % n;
        this.track.scrollTo({ left: i * this.track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
        this.setActive(i);
      }
      goToMedia(mediaId) {
        var idx = this.slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(mediaId); });
        if (idx > -1) this.go(idx);
      }
      setActive(i) {
        this.index = i;
        if (this.counter) this.counter.textContent = i + 1;
        this.thumbs.forEach(function (t, k) {
          if (k === i) { t.setAttribute('aria-current', 'true'); t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' }); }
          else t.removeAttribute('aria-current');
        });
      }
    });
  }

  /* ---------------- Enhanced dropdown (keeps the native <select> as source of truth) ---------------- */
  var dhSelectId = 0;
  if (!customElements.get('dh-select')) {
    customElements.define('dh-select', class extends HTMLElement {
      connectedCallback() {
        if (this.enhanced) return;
        this.native = this.querySelector('select');
        if (!this.native) return;
        this.enhanced = true;
        this.uid = 'dhsel' + (++dhSelectId);
        this.label = this.querySelector('.dh-select__label');
        this.currentLabel = this.querySelector('[data-dh-current-label]');
        this.build();
        this.classList.add('is-enhanced');
        this.native.setAttribute('tabindex', '-1');
        this.native.setAttribute('aria-hidden', 'true');
        if (this.label) this.label.setAttribute('for', this.uid + '-btn');
        var self = this;
        this.native.addEventListener('change', function () { self.sync(); });
        document.addEventListener('click', function (e) { if (!self.contains(e.target)) self.close(); });
      }
      build() {
        var self = this;
        this.button = document.createElement('button');
        this.button.type = 'button';
        this.button.className = 'dh-select__button';
        this.button.id = this.uid + '-btn';
        this.button.setAttribute('aria-haspopup', 'listbox');
        this.button.setAttribute('aria-expanded', 'false');
        this.button.setAttribute('aria-controls', this.uid + '-list');
        this.panel = document.createElement('ul');
        this.panel.className = 'dh-select__panel';
        this.panel.id = this.uid + '-list';
        this.panel.setAttribute('role', 'listbox');
        this.panel.setAttribute('tabindex', '-1');
        if (this.label) this.panel.setAttribute('aria-label', this.label.textContent.split(':')[0].trim());
        Array.prototype.forEach.call(this.native.options, function (opt, i) {
          var li = document.createElement('li');
          li.className = 'dh-select__option';
          li.id = self.uid + '-opt-' + i;
          li.setAttribute('role', 'option');
          li.dataset.value = opt.value;
          if (opt.dataset.swatch) {
            var sw = document.createElement('span');
            sw.className = 'dh-swatch';
            sw.style.setProperty('--sw', opt.dataset.swatch);
            li.appendChild(sw);
          }
          var txt = document.createElement('span');
          txt.textContent = opt.textContent;
          li.appendChild(txt);
          li.insertAdjacentHTML('beforeend', '<svg class="dh-select__tick" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>');
          li.addEventListener('click', function () { self.choose(i); });
          li.addEventListener('mousemove', function () { self.setActive(i); });
          self.panel.appendChild(li);
        });
        this.native.insertAdjacentElement('afterend', this.button);
        this.button.insertAdjacentElement('afterend', this.panel);
        this.button.addEventListener('click', function () { self.isOpen ? self.close() : self.open(); });
        this.button.addEventListener('keydown', function (e) { self.onKey(e); });
        this.panel.addEventListener('keydown', function (e) { self.onKey(e); });
        this.sync();
      }
      sync() {
        var i = this.native.selectedIndex;
        var opt = this.native.options[i];
        if (!opt) return;
        var html = '';
        if (opt.dataset.swatch) html += '<span class="dh-swatch" style="--sw:' + opt.dataset.swatch.replace(/"/g, '') + '"></span>';
        html += '<span class="dh-select__value"></span><svg class="dh-select__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
        this.button.innerHTML = html;
        this.button.querySelector('.dh-select__value').textContent = opt.textContent;
        if (this.currentLabel) this.currentLabel.textContent = opt.textContent;
        Array.prototype.forEach.call(this.panel.children, function (li, k) { li.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      }
      markAvailability(map) {
        Array.prototype.forEach.call(this.panel.children, function (li) {
          li.classList.toggle('is-unavailable', map && map[li.dataset.value] === false);
        });
      }
      open() {
        this.isOpen = true;
        this.panel.classList.add('is-open');
        this.button.setAttribute('aria-expanded', 'true');
        this.setActive(this.native.selectedIndex);
        var active = this.panel.children[this.native.selectedIndex];
        if (active) active.scrollIntoView({ block: 'nearest' });
        this.panel.focus({ preventScroll: true });
      }
      close(returnFocus) {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.panel.classList.remove('is-open');
        this.button.setAttribute('aria-expanded', 'false');
        this.panel.removeAttribute('aria-activedescendant');
        if (returnFocus) this.button.focus();
      }
      setActive(i) {
        this.activeIndex = i;
        var self = this;
        Array.prototype.forEach.call(this.panel.children, function (li, k) { li.classList.toggle('is-active', k === i); });
        var li = this.panel.children[i];
        if (li) { this.panel.setAttribute('aria-activedescendant', li.id); li.scrollIntoView({ block: 'nearest' }); }
      }
      choose(i) {
        if (this.native.selectedIndex !== i) {
          this.native.selectedIndex = i;
          this.native.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.sync();
        this.close(true);
      }
      onKey(e) {
        var n = this.native.options.length;
        var i = typeof this.activeIndex === 'number' ? this.activeIndex : this.native.selectedIndex;
        switch (e.key) {
          case 'ArrowDown': e.preventDefault(); if (!this.isOpen) this.open(); else this.setActive(Math.min(n - 1, i + 1)); break;
          case 'ArrowUp': e.preventDefault(); if (!this.isOpen) this.open(); else this.setActive(Math.max(0, i - 1)); break;
          case 'Home': if (this.isOpen) { e.preventDefault(); this.setActive(0); } break;
          case 'End': if (this.isOpen) { e.preventDefault(); this.setActive(n - 1); } break;
          case 'Enter': case ' ':
            e.preventDefault();
            if (this.isOpen) this.choose(i); else this.open();
            break;
          case 'Escape': if (this.isOpen) { e.preventDefault(); this.close(true); } break;
          case 'Tab': this.close(); break;
          default:
            if (this.isOpen && e.key.length === 1) {
              var ch = e.key.toLowerCase();
              for (var k = 1; k <= n; k++) {
                var idx = (i + k) % n;
                if (this.native.options[idx].textContent.trim().toLowerCase().indexOf(ch) === 0) { this.setActive(idx); break; }
              }
            }
        }
      }
    });
  }

  /* ---------------- Cart helpers ---------------- */
  function fetchCart() {
    return fetch((window.routes ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function isGiftLine(item) {
    return item && item.properties && (item.properties._dh_gift === '1' || item.properties._dh_gift === 1);
  }
  function qualifies(item) {
    var ids = C.qualifyingProductIds || [];
    if (!ids.length) return item.product_id !== C.giftProductId;
    return ids.indexOf(item.product_id) > -1;
  }
  function renderDrawerSections(state) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !state || !state.sections) return false;
    var parse = function (html, sel) { var doc = new DOMParser().parseFromString(html, 'text/html'); var el = doc.querySelector(sel); return el ? el.innerHTML : null; };
    if (state.sections['cart-drawer']) {
      var target = document.getElementById('CartDrawer');
      var html = parse(state.sections['cart-drawer'], '#CartDrawer');
      if (target && html !== null) target.innerHTML = html;
      var overlay = document.getElementById('CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
    }
    if (state.sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var bhtml = parse(state.sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && bhtml !== null) bubble.innerHTML = bhtml;
    }
    drawer.classList.toggle('is-empty', state.item_count === 0);
    initReveal(drawer);
    return true;
  }

  var syncing = false;
  var giftAutoFailed = false;
  // Keeps the free gift in step with the cart: added automatically next to a qualifying harness,
  // removed when no harness is left, never duplicated and never more than one.
  function syncGift(cart) {
    if (syncing || !C.giftVariantId) return Promise.resolve();
    var p = cart && Array.isArray(cart.items) && typeof cart.item_count === 'number' ? Promise.resolve(cart) : fetchCart();
    return p.then(function (state) {
      var gifts = state.items.filter(isGiftLine);
      var hasQualifying = state.items.some(function (i) { return !isGiftLine(i) && qualifies(i); });
      if (!gifts.length) {
        if (!hasQualifying || !C.offerEnabled || giftAutoFailed) return;
        syncing = true;
        var addBody = {
          items: [{ id: C.giftVariantId, quantity: 1, properties: { _dh_gift: '1' } }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        };
        return fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(addBody)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            syncing = false;
            if (!res || res.status) { giftAutoFailed = true; return; }
            if (!renderDrawerSections(res) && /\/cart\/?$/.test(window.location.pathname)) window.location.reload();
          })
          .catch(function () { syncing = false; giftAutoFailed = true; });
      }
      var change = null;
      if (!hasQualifying) change = { id: gifts[0].key, quantity: 0 };
      else if (gifts.length > 1) change = { id: gifts[1].key, quantity: 0 };
      else if (gifts[0].quantity > 1) change = { id: gifts[0].key, quantity: 1 };
      if (!change) return;
      syncing = true;
      var body = Object.assign(change, { sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname });
      return fetch(window.routes.cart_change_url, Object.assign(fetchConfigSafe(), { body: JSON.stringify(body) }))
        .then(function (r) { return r.json(); })
        .then(function (next) {
          syncing = false;
          if (!renderDrawerSections(next) && /\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
          return syncGift(next);
        })
        .catch(function () { syncing = false; });
    });
  }
  function fetchConfigSafe() {
    if (typeof window.fetchConfig === 'function') return window.fetchConfig();
    return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
  }
  window.DHSyncGift = syncGift;

  function addItems(lines, opts) {
    opts = opts || {};
    var drawer = document.querySelector('cart-drawer');
    return fetchCart().then(function (cart) {
      var hasGift = cart.items.some(isGiftLine);
      var items = lines.slice();
      var addsQualifying = items.some(function (l) { return l._qualifies; });
      var withGift = C.offerEnabled && C.giftVariantId && addsQualifying && !hasGift;
      if (withGift) items.push({ id: C.giftVariantId, quantity: 1, properties: { _dh_gift: '1' } });
      var send = function (list) {
        var body = { items: list.map(function (l) { var o = { id: l.id, quantity: l.quantity || 1 }; if (l.properties) o.properties = l.properties; return o; }) };
        if (drawer) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
        return fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); });
      };
      return send(items).then(function (res) {
        if (res && res.status && withGift) return send(lines);
        return res;
      });
    }).then(function (res) {
      if (res && res.status) throw new Error(res.description || res.message || 'Could not add to cart');
      if (drawer) {
        drawer.classList.remove('is-empty');
        if (opts.activeElement && drawer.setActiveElement) drawer.setActiveElement(opts.activeElement);
        drawer.renderContents(res);
      } else {
        window.location.href = window.routes.cart_url;
      }
      var ev = pubSubEvents();
      if (typeof window.publish === 'function' && ev) {
        window.publish(ev.cartUpdate, { source: 'dh-product-form', cartData: res });
      }
      return res;
    });
  }
  window.DHAddItems = addItems;

  /* ---------------- Product form ---------------- */
  if (!customElements.get('dh-product-form')) {
    customElements.define('dh-product-form', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.dh-pdp') || this.closest('section[data-section]');
        var jsonEl = this.section && this.section.querySelector('[data-dh-product-json]');
        if (!jsonEl) return;
        this.product = JSON.parse(jsonEl.textContent);
        this.form = this.querySelector('form');
        this.idInput = this.querySelector('[data-dh-variant-input]');
        this.selects = Array.prototype.slice.call(this.querySelectorAll('[data-dh-option]'));
        this.atc = this.querySelector('[data-dh-atc]');
        this.atcLabel = this.querySelector('[data-dh-atc-label]');
        this.error = this.querySelector('[data-dh-error]');
        this.nameInput = this.querySelector('[data-dh-name]');
        this.phoneInput = this.querySelector('[data-dh-phone]');
        this.preview = this.querySelector('[data-dh-preview]');
        this.previewPhone = this.querySelector('[data-dh-preview-phone]');
        this.variantPreview = this.querySelector('.dh-variant-preview__img');
        this.upsell = this.querySelector('[data-dh-upsell]');
        this.qualifiesFlag = this.section.dataset.qualifies === 'true';
        var self = this;
        this.selects.forEach(function (s) { s.addEventListener('change', function () { self.onVariantChange(); }); });
        if (this.upsell) this.upsell.addEventListener('change', function () { self.refreshLabel(); });
        if (this.nameInput) this.nameInput.addEventListener('input', function () {
          var v = self.nameInput.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ' \-]/g, '').replace(/\s{2,}/g, ' ').slice(0, 15);
          if (v !== self.nameInput.value) self.nameInput.value = v;
          if (self.preview) self.preview.textContent = v.trim() ? v.trim().toUpperCase() : (self.preview.dataset.placeholder || 'YOUR DOG NAME');
          self.nameInput.removeAttribute('aria-invalid');
          self.clearError();
        });
        if (this.phoneInput) this.phoneInput.addEventListener('input', function () {
          var v = self.phoneInput.value.replace(/[^0-9+()\- ]/g, '').slice(0, 20);
          if (v !== self.phoneInput.value) self.phoneInput.value = v;
          if (self.previewPhone) self.previewPhone.textContent = v.trim() || self.previewPhone.dataset.placeholder || 'PHONE NUMBER';
          self.phoneInput.removeAttribute('aria-invalid');
          self.clearError();
        });
        this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
        this.updateAvailability();
        this.initSticky();
      }
      currentOptions() { return this.selects.map(function (s) { return s.value; }); }
      upsellPrice() {
        return this.upsell && this.upsell.checked ? (parseInt(this.upsell.dataset.price, 10) || 0) : 0;
      }
      refreshLabel() {
        var v = this.variant || this.findVariant(this.currentOptions());
        if (!v || !v.available || !this.atcLabel) return;
        this.atcLabel.textContent = 'Add to cart · ' + money(v.price + this.upsellPrice());
      }
      findVariant(opts) {
        return this.product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      }
      onVariantChange() {
        var v = this.findVariant(this.currentOptions());
        this.variant = v;
        this.clearError();
        if (!v) { this.setButton(false, 'Unavailable'); return; }
        this.idInput.value = v.id;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        this.renderPrice(v);
        this.setButton(v.available, v.available ? 'Add to cart · ' + money(v.price + this.upsellPrice()) : 'Sold out');
        var stock = this.section.querySelector('[data-dh-stock]');
        if (stock) {
          stock.classList.toggle('is-out', !v.available);
          var st = stock.querySelector('[data-dh-stock-text]');
          if (st) st.textContent = v.available ? (st.dataset.inStock || (st.dataset.inStock = st.textContent)) : 'Sold out';
        }
        if (this.variantPreview && v.featured_media_url) {
          this.variantPreview.removeAttribute('srcset');
          this.variantPreview.removeAttribute('sizes');
          this.variantPreview.src = v.featured_media_url;
        }
        this.updateAvailability();
      }
      renderPrice(v) {
        var q = function (root, sel) { return root.querySelector(sel); };
        var s = this.section;
        var price = q(s, '[data-dh-price]'), compare = q(s, '[data-dh-compare]'), save = q(s, '[data-dh-save]');
        var pct = q(s, '[data-dh-save-pct]'), amount = q(s, '[data-dh-save-amount]'), line = q(s, '[data-dh-save-line]');
        var onSale = v.compare_at_price > v.price;
        if (price) price.textContent = money(v.price);
        if (compare) { compare.hidden = !onSale; compare.textContent = onSale ? money(v.compare_at_price) : ''; }
        if (save) save.hidden = !onSale;
        if (pct && onSale) pct.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        if (amount && onSale) amount.textContent = money(v.compare_at_price - v.price);
        if (line) line.hidden = !onSale;
        var sp = q(s, '[data-dh-sticky-price]'), sc = q(s, '[data-dh-sticky-compare]');
        if (sp) sp.textContent = money(v.price);
        if (sc) { sc.hidden = !onSale; if (onSale) sc.textContent = money(v.compare_at_price); }
      }
      updateAvailability() {
        var self = this;
        var opts = this.currentOptions();
        this.selects.forEach(function (sel, idx) {
          var host = sel.closest('dh-select');
          if (!host || !host.markAvailability) return;
          var map = {};
          Array.prototype.forEach.call(sel.options, function (o) {
            var test = opts.slice(); test[idx] = o.value;
            var v = self.findVariant(test);
            map[o.value] = !!(v && v.available);
          });
          host.markAvailability(map);
        });
      }
      setButton(enabled, label) {
        if (!this.atc) return;
        if (enabled) { this.atc.removeAttribute('disabled'); } else { this.atc.setAttribute('disabled', 'disabled'); }
        if (this.atcLabel && label) this.atcLabel.textContent = label;
        var sb = this.section.querySelector('[data-dh-sticky-btn]');
        if (sb) { sb.disabled = !enabled; sb.textContent = enabled ? 'Add to cart' : label; }
      }
      showError(msg, focusEl) {
        if (!this.error) return;
        this.error.textContent = msg;
        this.error.hidden = false;
        if (focusEl) { focusEl.setAttribute('aria-invalid', 'true'); focusEl.focus(); }
      }
      clearError() { if (this.error) { this.error.hidden = true; this.error.textContent = ''; } }
      propertyKey(input, fallback) {
        // Field names look like properties[Dog name]; the label inside the brackets is what appears on the order.
        var m = input && input.name ? input.name.match(/^properties\[(.+)\]$/) : null;
        return m ? m[1] : fallback;
      }
      properties() {
        var props = {};
        if (this.nameInput) {
          var name = (this.nameInput.value || '').trim().replace(/\s{2,}/g, ' ');
          if (!name && this.nameInput.required) { this.showError("Please enter your dog's name for the patch.", this.nameInput); return null; }
          if (name) {
            if (!/^[A-Za-zÀ-ÖØ-öø-ÿ' \-]{1,15}$/.test(name)) { this.showError("Use letters, spaces, apostrophes or hyphens only (max 15).", this.nameInput); return null; }
            props[this.propertyKey(this.nameInput, 'Dog name')] = name;
          }
        }
        if (this.phoneInput) {
          var phone = (this.phoneInput.value || '').trim();
          if (!phone && this.phoneInput.required) { this.showError('Please enter a phone number for the patch.', this.phoneInput); return null; }
          if (phone) {
            if (!/^[0-9+()\- ]{6,20}$/.test(phone) || phone.replace(/\D/g, '').length < 6) { this.showError('Please check the phone number (digits, spaces, +, - and brackets only).', this.phoneInput); return null; }
            props[this.propertyKey(this.phoneInput, 'Phone number')] = phone;
          }
        }
        return props;
      }
      submit() {
        var self = this;
        if (!this.atc || this.atc.hasAttribute('disabled') || this.atc.getAttribute('aria-disabled') === 'true') return;
        this.clearError();
        var props = this.properties();
        if (props === null) { this.scrollIntoViewIfNeeded(); return; }
        var id = parseInt(this.idInput.value, 10);
        this.atc.setAttribute('aria-disabled', 'true');
        this.atc.classList.add('loading');
        var spinner = this.atc.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
        var line = { id: id, quantity: 1, _qualifies: this.qualifiesFlag };
        if (Object.keys(props).length) line.properties = props;
        var lines = [line];
        if (this.upsell && this.upsell.checked) {
          var upsellId = parseInt(this.upsell.value, 10);
          if (upsellId) lines.push({ id: upsellId, quantity: 1 });
        }
        addItems(lines, { activeElement: this.atc })
          .catch(function (err) { self.showError(err.message || 'Something went wrong. Please try again.'); })
          .finally(function () {
            self.atc.removeAttribute('aria-disabled');
            self.atc.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }
      scrollIntoViewIfNeeded() {
        var r = this.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) this.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      }
      initSticky() {
        var bar = this.section.querySelector('[data-dh-sticky]');
        var btn = this.section.querySelector('[data-dh-sticky-btn]');
        if (!bar || !btn || !('IntersectionObserver' in window)) return;
        var self = this;
        btn.addEventListener('click', function () {
          if (self.nameInput && self.nameInput.required && !(self.nameInput.value || '').trim()) {
            self.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          }
          self.submit();
        });
        var atcVisible = true, footerVisible = false;
        var update = function () {
          var show = !atcVisible && !footerVisible;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          btn.tabIndex = show ? 0 : -1;
        };
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { atcVisible = e.isIntersecting || e.boundingClientRect.top > 0; });
          update();
        }).observe(this.atc);
        var footer = document.querySelector('.footer, footer');
        if (footer) new IntersectionObserver(function (entries) { entries.forEach(function (e) { footerVisible = e.isIntersecting; }); update(); }).observe(footer);
      }
    });
  }

  /* ---------------- Quick add buttons on cards: <button data-dh-quick-add data-variant-id data-qualifies> ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dh-quick-add]');
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-disabled') === 'true') return;
    b.setAttribute('aria-disabled', 'true');
    addItems([{ id: parseInt(b.dataset.variantId, 10), quantity: 1, _qualifies: b.dataset.qualifies === 'true' }], { activeElement: b })
      .catch(function () { window.location.href = b.getAttribute('href') || window.routes.cart_url; })
      .finally(function () { b.removeAttribute('aria-disabled'); });
  });

  /* ---------------- Re-add the free gift from the cart drawer ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dh-add-gift]');
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-disabled') === 'true') return;
    b.setAttribute('aria-disabled', 'true');
    addItems([{ id: parseInt(b.dataset.variantId, 10), quantity: 1, properties: { _dh_gift: '1' } }], { activeElement: b })
      .catch(function () { b.removeAttribute('aria-disabled'); });
  });

  /* ---------------- Boot ---------------- */
  function boot() {
    initReveal(document);
    var ev = pubSubEvents();
    if (typeof window.subscribe === 'function' && ev) {
      window.subscribe(ev.cartUpdate, function (event) {
        // Let Dawn finish re-rendering first, then make sure the gift line is still valid.
        setTimeout(function () { syncGift(event && event.cartData); }, 50);
      });
    }
    // Validate on load too (e.g. a gift left alone in the cart from a previous visit).
    if (document.querySelector('cart-drawer') || /\/cart\/?$/.test(window.location.pathname)) syncGift();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
})();
